import React from "react"
import {useTranslation} from "react-i18next"

import {TReachMeta} from "../../../queries/reachEngine"
import {CardHeadline, StackBar, StatRow} from "./CardStats"
import {DashboardCard} from "./DashboardCard"

export const SalesFlowsCard: React.FC<{salesFlows: TReachMeta["sales_flows"]}> = ({salesFlows}) => {
  const {t} = useTranslation()

  const items = [
    {key: "active", label: t("ReachEngine_SalesFlows_Active"), value: salesFlows.active, dotClassName: "bg-cr-blue"},
    {
      key: "finished",
      label: t("ReachEngine_SalesFlows_Finished"),
      value: salesFlows.finished,
      dotClassName: "bg-cr-blue-mid-light",
    },
    {key: "planned", label: t("ReachEngine_SalesFlows_Planned"), value: salesFlows.planned, dotClassName: "bg-cr-cyan"},
  ]

  return (
    <DashboardCard title={t("ReachEngine_SalesFlows_Title")} subtitle={t("ReachEngine_SalesFlows_Subtitle")}>
      <CardHeadline value={salesFlows.total} />
      <StackBar segments={items.map(({key, value, dotClassName}) => ({key, value, className: dotClassName}))} />
      <StatRow items={items} />
    </DashboardCard>
  )
}
